"use client";
import { createContext, useContext } from "react";
import { PayloadApiClient } from "./PayloadApiClient";

type PayloadContextValue = {
  payloadApi: PayloadApiClient
}

const PayloadContext = createContext<PayloadContextValue | null>(null)

export function PayloadProvider(props: { locale: string, children: React.ReactNode }) {
  const payloadApiClient = new PayloadApiClient({
    locale: props.locale,
    baseURL: process.env.NEXT_PUBLIC_PAYLOAD_API_URL as string,
  })
  return (
    <PayloadContext.Provider value={{
      payloadApi: payloadApiClient
    }}>
      {props.children}
    </PayloadContext.Provider>
  );
}

export function usePayload() {
  const payload = useContext(PayloadContext);
  if (!payload) {
    throw new Error('Payload context is null.');
  }
  return payload;
}
